<template>
	<el-dialog :visible="visible" width="780px" top="6vh" custom-class="jin10-dialog"
		:show-close="true" append-to-body @close="$emit('close')">
		<!-- 头部: 还原金十蓝色导航 -->
		<div slot="title" class="j10-header">
			<div class="j10-brand">
				<span class="j10-logo">金十数据</span>
				<span class="j10-slogan">比新闻更快的新闻</span>
			</div>
			<div class="j10-tabs">
				<div v-for="t in tabs" :key="t.key" class="j10-tab" :class="{active: tab === t.key}"
					@click="switchTab(t.key)">{{ t.label }}</div>
			</div>
		</div>
		<div v-loading="loading" class="j10-body">
			<!-- 快讯 -->
			<div v-if="tab === 'flash'" class="j10-flash">
				<div v-for="f in flashList" :key="f.time" class="j10-flash-item" :class="{vip: f.important}">
					<div class="j10-flash-time">
						<span class="j10-dot" :class="{red: f.important}"></span>{{ fmtTime(f.time) }}
					</div>
					<div class="j10-flash-content" v-html="fmtContent(f.content)"></div>
				</div>
				<div v-if="!loading && !flashList.length" class="j10-empty">暂无快讯数据</div>
			</div>
			<!-- 头条 -->
			<div v-if="tab === 'articles'" class="j10-articles">
				<a v-for="a in articles" :key="a.id" :href="a.url" target="_blank" class="j10-article">
					<div class="j10-article-title">{{ a.title || '（标题加载中…）' }}</div>
					<div class="j10-article-meta">
						<span class="j10-src">金十头条</span>{{ fmtTime(a.collected_at) }}
					</div>
				</a>
				<div v-if="!loading && !articles.length" class="j10-empty">暂无头条数据</div>
			</div>
			<!-- 财经日历 -->
			<div v-if="tab === 'calendar'" class="j10-calendar">
				<div v-for="(rows, d) in calByDate" :key="d">
					<div class="j10-cal-date" :class="{today: isToday(d)}">
						{{ fmtDate(d) }}<span v-if="isToday(d)" class="j10-today-tag">今天</span>
					</div>
					<table class="j10-cal-table">
						<thead>
							<tr>
								<th class="c-time">时间</th>
								<th class="c-country">国家</th>
								<th class="c-event">事件</th>
								<th class="c-num">前值</th>
								<th class="c-num">预测值</th>
								<th class="c-num">公布值</th>
								<th class="c-star">重要性</th>
							</tr>
						</thead>
						<tbody v-for="(r, i) in rows" :key="d + i">
							<tr :class="{published: isPublished(r), sel: selKey === evtKey(r)}" @click="openEvt(r)">
								<td class="c-time">{{ r.time && r.time.indexOf(':') >= 0 ? r.time : '待定' }}</td>
								<td class="c-country">{{ flag(r.country) }} {{ r.country }}</td>
								<td class="c-event" :title="r.event">{{ shortEvent(r.event) }}</td>
								<td class="c-num">{{ r.previous }}</td>
								<td class="c-num">{{ r.forecast }}</td>
								<td class="c-num" :class="actualCls(r)">{{ r.actual }}</td>
								<td class="c-star">
									<span class="j10-star" :class="'star-' + starLevel(r.importance)"
										:title="r.importance">{{ stars(r.importance) }}</span>
								</td>
							</tr>
							<!-- 点击展开: 事件详情卡片 + 关联快讯(仿金十日历点击效果) -->
							<tr v-if="selKey === evtKey(r)" class="j10-cal-detail">
								<td colspan="7">
									<div class="j10-evt-detail">
										<div class="ev-title">{{ r.event }}</div>
										<div class="ev-grid">
											<div class="ev-cell"><span class="ev-k">报告期</span>{{ r.period || '-' }}</div>
											<div class="ev-cell"><span class="ev-k">前值</span>{{ r.previous || '-' }}</div>
											<div class="ev-cell"><span class="ev-k">预测值</span>{{ r.forecast || '-' }}</div>
											<div class="ev-cell"><span class="ev-k">公布值</span><b :class="actualCls(r)">{{ r.actual || '待公布' }}</b></div>
											<div class="ev-cell"><span class="ev-k">重要性</span><span class="j10-star" :class="'star-' + starLevel(r.importance)">{{ stars(r.importance) }}</span></div>
											<div class="ev-cell"><span class="ev-k">公布时间</span>{{ r.date }} {{ r.time && r.time.indexOf(':') >= 0 ? r.time : '待定' }}</div>
										</div>
										<div class="ev-flash">
											<div class="ev-flash-title">关联快讯（近24小时）</div>
											<div v-for="f in relFlash(r)" :key="f.time" class="ev-flash-item">
												<span class="ev-flash-time">{{ fmtTime(f.time) }}</span>
												<span v-html="fmtContent(f.content)"></span>
											</div>
											<div v-if="!relFlash(r).length" class="ev-flash-empty">
												{{ isPublished(r) ? '未匹配到关联快讯' : '该事件尚未公布，公布后相关快讯会自动关联' }}
											</div>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-if="!loading && !calendar.length" class="j10-empty">暂无日历数据</div>
			</div>
		</div>
		<div class="j10-footer">
			<span>数据来源：金十快讯/头条公开页 + 东方财富全球经济日历 · 仅保留24小时内数据 · 每60秒自动刷新</span>
			<span class="j10-refresh" @click="load()">立即刷新</span>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: "chatJin10Dialog",
	props: {
		visible: Boolean,
		initTab: { type: String, default: 'flash' }
	},
	data() {
		return {
			tab: 'flash',
			loading: false,
			flashList: [],
			articles: [],
			calendar: [],
			selKey: '', // 日历展开的事件行 key
			flashCache: [], // 详情卡关联快讯用(点开后拉一次缓存)
			timer: null,
			tabs: [
				{ key: 'flash', label: '快讯' },
				{ key: 'articles', label: '头条' },
				{ key: 'calendar', label: '日历' }
			]
		};
	},
	computed: {
		calByDate() {
			const map = {};
			this.calendar.forEach((r) => {
				if (!map[r.date]) map[r.date] = [];
				map[r.date].push(r);
			});
			return map;
		}
	},
	watch: {
		visible(v) {
			if (v) {
				this.tab = this.initTab || 'flash';
				this.load();
				this.timer = setInterval(() => this.load(), 60000);
			} else if (this.timer) {
				clearInterval(this.timer);
				this.timer = null;
			}
		}
	},
	beforeDestroy() {
		if (this.timer) { clearInterval(this.timer); this.timer = null; }
	},
	methods: {
		switchTab(k) {
			this.tab = k;
			this.load();
		},
		load() {
			if (!this.visible) return;
			this.loading = true;
			const urls = {
				flash: '/jin10/flash?limit=100',
				articles: '/jin10/articles?limit=30',
				calendar: '/jin10/calendar'
			};
			fetch(urls[this.tab]).then((r) => r.json()).then((d) => {
				if (d && d.code === 0) {
					if (this.tab === 'flash') this.flashList = d.data || [];
					else if (this.tab === 'articles') this.articles = d.data || [];
					else this.calendar = d.data || [];
				}
			}).catch(() => { }).finally(() => { this.loading = false; });
		},
		fmtTime(t) {
			if (!t) return '';
			// '2026-08-23 00:14:22' / ISO -> MM-DD HH:mm
			const s = String(t).replace('T', ' ');
			const m = s.match(/(\d{2,4})-(\d{2})-(\d{2})[ T]?(\d{2}):(\d{2})/);
			if (!m) return s.slice(5, 16);
			return `${m[2]}-${m[3]} ${m[4]}:${m[5]}`;
		},
		fmtDate(d) {
			const m = String(d).match(/(\d{4})-(\d{2})-(\d{2})/);
			if (!m) return d;
			const wk = ['日', '一', '二', '三', '四', '五', '六'][new Date(+m[1], +m[2] - 1, +m[3]).getDay()];
			return `${m[1]}年${+m[2]}月${+m[3]}日 周${wk}`;
		},
		isToday(d) {
			const n = new Date();
			const p = (x) => (x < 10 ? '0' + x : '' + x);
			return d === `${n.getFullYear()}-${p(n.getMonth() + 1)}-${p(n.getDate())}`;
		},
		fmtContent(c) {
			// 纯文本 -> 首段【】标题加粗高亮
			const safe = String(c || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
			return safe.replace(/【([^】]+)】/, '<span class="j10-hl">【$1】</span>').replace(/\n/g, '<br>');
		},
		flag(country) {
			const map = {
				'美国': '🇺🇸', '中国': '🇨🇳', '中国台湾': '🇨🇳', '中国香港': '🇭🇰',
				'欧元区': '🇪🇺', '欧盟': '🇪🇺', '德国': '🇩🇪', '法国': '🇫🇷', '英国': '🇬🇧',
				'日本': '🇯🇵', '韩国': '🇰🇷', '加拿大': '🇨🇦', '澳大利亚': '🇦🇺',
				'新西兰': '🇳🇿', '瑞士': '🇨🇭', '新加坡': '🇸🇬', '俄罗斯': '🇷🇺', '印度': '🇮🇳'
			};
			return map[country] || '🏳️';
		},
		shortEvent(e) {
			// '美国:非农就业人口变动' -> 去掉与国家重复的前缀
			const i = String(e).indexOf(':');
			return i > 0 && i < 8 ? String(e).slice(i + 1) : e;
		},
		isPublished(r) {
			if (!r.actual || r.actual === '-') return false;
			const now = new Date();
			const p = (x) => (x < 10 ? '0' + x : '' + x);
			const nowStr = `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())} ${p(now.getHours())}:${p(now.getMinutes())}`;
			const t = `${r.date} ${r.time && r.time.indexOf(':') >= 0 ? r.time : '00:00'}`;
			return t <= nowStr;
		},
		actualCls(r) {
			if (!this.isPublished(r)) return '';
			const a = parseFloat(String(r.actual).replace(/[%+,亿万]/g, ''));
			const f = parseFloat(String(r.forecast).replace(/[%+,亿万]/g, ''));
			if (isNaN(a) || isNaN(f)) return 'has-val';
			return a > f ? 'val-up' : (a < f ? 'val-down' : 'has-val');
		},
		starLevel(imp) {
			return imp === '高' ? 3 : (imp === '中' ? 2 : 1);
		},
		stars(imp) {
			return '★'.repeat(this.starLevel(imp));
		},
		// ---------- 日历事件点击展开(仿金十: 详情+关联快讯) ----------
		evtKey(r) {
			return r.date + '|' + r.time + '|' + r.event;
		},
		openEvt(r) {
			const k = this.evtKey(r);
			this.selKey = this.selKey === k ? '' : k;
			// 首次展开时拉一次快讯做关联匹配缓存
			if (this.selKey && !this.flashCache.length) {
				fetch('/jin10/flash?limit=500').then((x) => x.json()).then((d) => {
					if (d && d.code === 0) this.flashCache = d.data || [];
				}).catch(() => { });
			}
		},
		evtKeywords(r) {
			// 事件名 -> 匹配关键词: 全名 + 去常见后缀的核心名(如 '非农就业人口变动' -> '非农就业人口')
			const kw = this.shortEvent(r.event);
			const kws = [kw];
			const stripped = kw.replace(/(季率|年率|月率|周率|人数|人口变动|变动|指数|初值|终值|人数变动)$/, '');
			if (stripped !== kw && stripped.length >= 2) kws.push(stripped);
			return kws;
		},
		relFlash(r) {
			if (!this.selKey || !this.flashCache.length) return [];
			const kws = this.evtKeywords(r);
			return this.flashCache.filter((f) => kws.some((k) => f.content.indexOf(k) >= 0)).slice(0, 5);
		}
	}
};
</script>

<style lang="scss">
.jin10-dialog {
	border-radius: 10px;
	overflow: hidden;

	.el-dialog__header {
		padding: 0;
		border-bottom: none;
	}

	.el-dialog__headerbtn {
		top: 16px;
		right: 16px;
		z-index: 2;

		i {
			color: #fff;
		}
	}

	.el-dialog__body {
		padding: 0;
	}
}

.j10-header {
	background: linear-gradient(135deg, #1a5cd6, #2d8cf0);
	padding: 14px 20px 0;
	color: #fff;

	.j10-brand {
		display: flex;
		align-items: baseline;
		gap: 10px;

		.j10-logo {
			font-size: 20px;
			font-weight: 700;
			letter-spacing: 1px;
		}

		.j10-slogan {
			font-size: 12px;
			opacity: .75;
		}
	}

	.j10-tabs {
		display: flex;
		margin-top: 12px;

		.j10-tab {
			padding: 8px 22px;
			font-size: 14px;
			cursor: pointer;
			border-radius: 6px 6px 0 0;
			opacity: .85;

			&.active {
				background: #fff;
				color: #1a5cd6;
				font-weight: 700;
				opacity: 1;
			}
		}
	}
}

.j10-body {
	height: 56vh;
	overflow-y: auto;
	background: #fff;
	padding: 14px 18px;
}

.j10-empty {
	text-align: center;
	color: #999;
	padding: 60px 0;
}

/* ---------- 快讯(还原金十时间轴) ---------- */
.j10-flash {
	.j10-flash-item {
		display: flex;
		padding: 10px 0;
		border-bottom: 1px dashed #eee;

		&.vip {
			background: #fff8f7;
			border-radius: 6px;
			padding: 10px 8px;
		}

		.j10-flash-time {
			flex: 0 0 92px;
			color: #8a94a6;
			font-size: 13px;
			padding-top: 2px;
			position: relative;

			.j10-dot {
				display: inline-block;
				width: 7px;
				height: 7px;
				border-radius: 50%;
				background: #c9d2e0;
				margin-right: 6px;
				vertical-align: 1px;

				&.red {
					background: #e74c3c;
					box-shadow: 0 0 4px rgba(231, 76, 60, .6);
				}
			}
		}

		.j10-flash-content {
			flex: 1;
			font-size: 14px;
			line-height: 1.7;
			color: #2b3340;
			word-break: break-all;

			.j10-hl {
				color: #e74c3c;
				font-weight: 700;
			}
		}
	}
}

/* ---------- 头条 ---------- */
.j10-articles {
	.j10-article {
		display: block;
		padding: 13px 10px;
		border-bottom: 1px dashed #eee;
		text-decoration: none;

		&:hover {
			background: #f5f8ff;
			border-radius: 6px;

			.j10-article-title {
				color: #1a5cd6;
			}
		}

		.j10-article-title {
			font-size: 15px;
			font-weight: 600;
			color: #2b3340;
			line-height: 1.5;
		}

		.j10-article-meta {
			margin-top: 6px;
			font-size: 12px;
			color: #98a2b3;

			.j10-src {
				display: inline-block;
				background: #fff0f0;
				color: #e74c3c;
				border-radius: 3px;
				font-size: 11px;
				padding: 1px 6px;
				margin-right: 8px;
			}
		}
	}
}

/* ---------- 财经日历(还原金十表格) ---------- */
.j10-calendar {
	.j10-cal-date {
		font-size: 14px;
		font-weight: 700;
		color: #2b3340;
		padding: 10px 4px 6px;

		&.today {
			color: #1a5cd6;
		}

		.j10-today-tag {
			display: inline-block;
			background: #1a5cd6;
			color: #fff;
			font-size: 11px;
			font-weight: 400;
			border-radius: 3px;
			padding: 1px 6px;
			margin-left: 8px;
			vertical-align: 1px;
		}
	}

	.j10-cal-table {
		width: 100%;
		border-collapse: collapse;
		font-size: 13px;

		th {
			background: #f4f6fa;
			color: #66707f;
			font-weight: 500;
			padding: 7px 6px;
			text-align: center;
		}

		tbody {
			cursor: pointer;

			&:hover tr:not(.j10-cal-detail) {
				background: #f5f8ff;
			}
		}

		tr.sel {
			background: #eef4ff;
		}

		td {
			padding: 8px 6px;
			border-bottom: 1px solid #f0f2f5;
			text-align: center;
			color: #3a4353;
		}

		.c-time {
			width: 52px;
			color: #8a94a6;
		}

		.c-country {
			width: 108px;
			text-align: left;
			white-space: nowrap;
		}

		.c-event {
			text-align: left;
			max-width: 210px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.c-num {
			width: 64px;
		}

		.c-star {
			width: 60px;

			.j10-star {
				letter-spacing: 1px;

				&.star-3 {
					color: #e74c3c;
				}

				&.star-2 {
					color: #f5a623;
				}

				&.star-1 {
					color: #c9d2e0;
				}
			}
		}

		tr.published {
			.c-num {
				font-weight: 600;
			}

			.val-up {
				color: #e74c3c;
			}

			.val-down {
				color: #0fb37f;
			}

			.has-val {
				color: #2b3340;
			}
		}
	}
}

/* 日历事件点击展开详情卡 */
.j10-cal-detail {
	cursor: default;

	td {
		padding: 0 !important;
		border-bottom: 1px solid #e3e9f5;
	}

	.j10-evt-detail {
		background: #f8faff;
		padding: 14px 18px;

		.ev-title {
			font-size: 15px;
			font-weight: 700;
			color: #1a5cd6;
			margin-bottom: 10px;
		}

		.ev-grid {
			display: flex;
			flex-wrap: wrap;
			gap: 8px 26px;
			margin-bottom: 12px;

			.ev-cell {
				font-size: 13px;
				color: #2b3340;

				.ev-k {
					color: #98a2b3;
					margin-right: 6px;
				}

				.val-up {
					color: #e74c3c;
				}

				.val-down {
					color: #0fb37f;
				}
			}
		}

		.ev-flash {
			border-top: 1px dashed #dde4f0;
			padding-top: 10px;

			.ev-flash-title {
				font-size: 12px;
				color: #66707f;
				font-weight: 600;
				margin-bottom: 6px;
			}

			.ev-flash-item {
				font-size: 13px;
				color: #3a4353;
				line-height: 1.7;
				padding: 3px 0;

				.ev-flash-time {
					color: #8a94a6;
					margin-right: 8px;
				}

				.j10-hl {
					color: #e74c3c;
					font-weight: 700;
				}
			}

			.ev-flash-empty {
				font-size: 12px;
				color: #98a2b3;
				padding: 4px 0;
			}
		}
	}
}

.j10-footer {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px 18px;
	border-top: 1px solid #f0f2f5;
	font-size: 12px;
	color: #98a2b3;
	background: #fafbfc;

	.j10-refresh {
		color: #1a5cd6;
		cursor: pointer;

		&:hover {
			text-decoration: underline;
		}
	}
}
</style>
